import { useState } from 'preact/hooks'
import { navigate } from 'raviger'

import { profile, setDisplayName } from '../utils/session'

const errorMessages = {
  bad_name: 'El nombre tiene que tener entre 3 y 24 caracteres.',
  name_taken: 'Ese nombre ya lo tiene otra persona.'
}

export function Welcome() {
  const [name, setName] = useState(profile.value?.displayName || '')
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)

  async function submit(event) {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await setDisplayName(name)
      navigate('/')
    } catch (e) {
      setError(errorMessages[e.code] || e.code)
    } finally {
      setBusy(false)
    }
  }

  return (
    <main class="page welcome">
      <h1>¡Hola!</h1>
      <p>
        Estás dentro como <strong>{profile.value?.email}</strong>.
        ¿Con qué nombre quieres salir en el leaderboard?
      </p>
      <form onSubmit={submit}>
        <input
          type="text"
          value={name}
          minLength={3}
          maxLength={24}
          placeholder="Tu nombre"
          onInput={(e) => setName(e.currentTarget.value)}
          autoFocus
          required
        />
        <button class="primary" type="submit" disabled={busy}>
          Guardar
        </button>
        {error && <p class="error">{error}</p>}
      </form>
    </main>
  )
}
